import { render, staticRenderFns } from "./LeagueRace.vue?vue&type=template&id=6a9f28d3&"
import script from "./LeagueRace.vue?vue&type=script&lang=js&"
export * from "./LeagueRace.vue?vue&type=script&lang=js&"
import style0 from "./LeagueRace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports